export default function fixNewsContent(content: string): string {
  if (!content) return "";

  // Prevents "DOMParser is not defined" on the server
  if (typeof window === "undefined") {
    return content;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(content, "text/html");

  doc.querySelectorAll("img").forEach((img) => {
    const alt = img.getAttribute("alt") || "";
    const src = img.getAttribute("src") || "";

    if (alt.startsWith("%3Csvg")) {
      try {
        const decodedSvg = decodeURIComponent(alt);
        const svgElement = parser.parseFromString(decodedSvg, "image/svg+xml")
          .documentElement;
        svgElement.setAttribute(
          "style",
          "max-width:100%;height:auto;display:block;margin:0 auto;"
        );

        img.replaceWith(svgElement);
      } catch (e) {
        console.warn("Failed to decode SVG from alt:", e);
      }
    } else if (src.startsWith("blob:")) {
      img.remove();
    } else {
      img.setAttribute(
        "style",
        "max-width:100%;height:auto;display:block;margin:0 auto;"
      );
    }
  });

  return doc.body.innerHTML;
}
